class StickyBar extends HTMLElement {
  constructor() {
    super();
    this.options = this.querySelectorAll('.jc-sticky-bar-variant-option');
    this.price = this.querySelector('.product-card__form-price')
  }

  connectedCallback() {
    console.log(this.price)
    this.options.forEach((option, index) => {
      option.addEventListener('click', () => {
        let selectedVariant = option.getAttribute('data-variant');
        this.querySelector('[name="id"]').value = selectedVariant;

        this.options.forEach(option => {
          option.classList.remove('active')
        });

        const productImages = this.querySelectorAll('[class^="productcard_image-"]');
        productImages.forEach((image) => {
          image.classList.add('jc-opacity-0');
        })

        let productCard = option.closest('.js-product-card');
        let imageElement = productCard.querySelector('.productcard_image-' + index);

        if (!imageElement) {
          imageElement = productCard.querySelector('.productcard_image-0');
        }

        if (imageElement) {
          imageElement.classList.remove('jc-opacity-0');
        }

        this.price.textContent = option.dataset.price;

        option.classList.add('active');
      })
    })
  }
}

customElements.define("sticky-bar", StickyBar)